import { t } from "i18next";
import { Button, Icon } from "@livingmap/hippo";

import styles from "@components/EditFeatureSidebar/Modals/Modal.module.scss";

interface Props {
  resetModal: () => void;
  onResetSidebar: () => void;
}

const ResetSidebar: React.FC<Props> = ({ resetModal, onResetSidebar }) => {
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h5 className={styles.title}>
          {t("modals.exit_and_create_new_link.title")}
        </h5>
        <button className={styles.closeButton} onClick={resetModal}>
          <Icon dataQA="reset-icon" name="close" size={18} />
        </button>
      </div>
      <div className={styles.contentContainer}>
        <p className={styles.description}>
          {t("modals.exit_and_create_new_link.description")}
        </p>
        <div className={styles.buttonWrapper}>
          <Button
            dataQA="keep-editing-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.keep_editing")}
            onClick={resetModal}
          />
          <Button
            dataQA="exit-button"
            type="primary"
            size="regular"
            style="filled"
            text={t("btn_labels.create_new_link")}
            onClick={onResetSidebar}
          />
        </div>
      </div>
    </div>
  );
};

export default ResetSidebar;
